import { useCallback } from 'react';

import { fg } from '@confluence/feature-gating';

export type DatabaseFeatureGate = 'dbAiFirstCreation';

export const useIsDatabaseFeatureEnabled = () => {
	const isDatabaseFeatureEnabled = useCallback((featureName: DatabaseFeatureGate) => {
		if (featureName === 'dbAiFirstCreation') {
			return fg('aifc_create_enabled_ga');
		}
		return false;
	}, []);

	return {
		isDatabaseFeatureEnabled,
	};
};
